import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useConfirmDialogState, } from '../../hooks/useConfirmDialog';
import { Button } from '../Button/Button';
import { Dialog } from '../Dialog/Dialog';
/**
 * A confirm dialog that is placed at the top level of the page
 * enabling the use of the useConfirmDialog hook.
 */
function ConfirmDialog() {
    const { confirmOptions, setConfirmOptions } = useConfirmDialogState();
    // We need to store the text content in a ref because the Dialog component
    // will transition to fade so we need to cache the text while we close.
    const textOptionsCached = React.useRef();
    React.useEffect(() => {
        if (confirmOptions) {
            textOptionsCached.current = {
                title: confirmOptions.title,
                content: confirmOptions.content,
                buttonCancelText: confirmOptions.buttonCancelText,
                buttonConfirmText: confirmOptions.buttonConfirmText,
                buttonConfirmColor: confirmOptions.buttonConfirmColor,
            };
        }
    }, [confirmOptions]);
    const { title, content, onCancel, onConfirm, buttonCancelText = 'Cancel', buttonConfirmText = 'Confirm', buttonConfirmColor, } = {
        ...textOptionsCached.current,
        ...confirmOptions,
    };
    return (_jsx(Dialog, { open: !!confirmOptions, onOpenChange: (open) => {
            if (!open) {
                setConfirmOptions(undefined);
            }
        }, children: _jsxs(Dialog.Content, { "aria-describedby": undefined, children: [_jsx(Dialog.Header, { children: _jsx(Dialog.Title, { children: title }) }), content, _jsxs(Dialog.Footer, { children: [_jsx(Button, { color: "transparent", onClick: (e) => {
                                onCancel?.(e);
                                if (e.defaultPrevented)
                                    return;
                                setConfirmOptions(undefined);
                            }, children: buttonCancelText }), _jsx(Button, { onClick: (e) => {
                                onConfirm?.(e);
                                if (e.defaultPrevented)
                                    return;
                                setConfirmOptions(undefined);
                            }, color: buttonConfirmColor, children: buttonConfirmText })] })] }) }));
}
export { ConfirmDialog };
//# sourceMappingURL=ConfirmDialog.js.map